const DRIVER_PLANNING = 'locatDriverPlanning';
const DRIVER_MISSION_DETAIL = 'locatDriverMissionDetail';

export { DRIVER_PLANNING, DRIVER_MISSION_DETAIL };
